export const PAGE_KEYS = {
  HOME: "home",
  CART: "cart",
  PRODUCT: "product",
  PRODUCT_DETAIL: "productDetail",
  PRODUCT_LIST: "productList",
  PRODUCT_SEARCH: "productSearch",
  CATEGORY: "category",
  PAYMENT: "payment",
  PAYMENT_SUCCESS: "paymentSuccess",
  ORDER_QUERY: "orderQuery",
  USER_CENTER: "userCenter",
  USER_COUPONS: "userCoupons",
  USER_PROFILE: "userProfile",
  USER_ORDER_DETAIL: "userOrderDetail",
  LOGIN: "login",
  PUBLIC_ORDER_DETAIL: "publicOrderDetail",
};

export default PAGE_KEYS;
